import { Fragment } from 'react';

export default function KbDashboard() {
    return (
        <Fragment>
            <div className="page-route-body">
                <div className="main-content-title">数据总览</div>
                <div className="main-content-body">首页</div>
            </div>

            <div className="page-route-body">
                <div className="main-content-title">功能导航</div>
                <div className="main-content-body"></div>
            </div>
        </Fragment>
    );
}
